import { CHECK_COMPANY_TENANT, CREDFIN_LIKE } from "../layouts/MainTenantconfig";
import { TENANT_ID } from "./api-factory"
import LocalStorage from './localStorageUtil';

// Hardcoded parameter: if true accept token, else don't
export const PARTICULAR_KEY = 'AIzaSyB-9HOhts6vij-Lx0dNmB4KoJOfPSUN9oA';
export const USE_TOKEN_AUTH = CHECK_COMPANY_TENANT(CREDFIN_LIKE) 
? true // true (for api token)
 : false;

const getAuthHeaderValue = () => {
    if (!USE_TOKEN_AUTH) return undefined;
    const token = LocalStorage.getFromLocalStorage('access_token');
    return token ? `bearer ${token}` : 'notoeken';
};

// Helper to define Authorization getter on an object
const addAuthGetter = (obj) => {
    // Object.defineProperty(obj, 'Authorization', {
    //     get: () => getAuthHeaderValue(),
    //     enumerable: true,
    //     configurable: true
    // });
    return obj;
};

// Helper to define a dual-mode header object (behaves as both options and flat headers)
const createDualHeader = (baseObj) => {
    const obj = { ...baseObj };
    // Object.defineProperty(obj, 'headers', {
    //     get: function() { return this; },
    //     enumerable: false, // Prevents serialization as a header key
    //     configurable: true
    // });
    // Object.defineProperty(obj, 'Authorization', {
    //     get: () => getAuthHeaderValue(),
    //     enumerable: true,
    //     configurable: true
    // });
    return obj;
};

const POST_HEADER = addAuthGetter({
    'Accept': 'application/json',
    'Content-Type': 'application/json',
});

const PUT_HEADERS = addAuthGetter({
    // 'Accept': 'application/json',
    'Content-Type': 'application/json',
});
const DELETE_HEADERS = addAuthGetter({
    'Accept': 'application/json',
    'Content-Type': 'application/json',
});
const POST_HEADER_NO_TOKEN = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
};

const MULTIPART_POST_HEADER = addAuthGetter({
    'Accept': 'application/json',
    'Content-Type': 'multipart/form-data',
});

const TENANT_POST_HEADER = addAuthGetter({
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Tenant-ID': TENANT_ID
});

const MULTIPART_TENANT_POST_HEADER = addAuthGetter({
    'Accept': 'application/json',
    'Content-Type': 'multipart/form-data',
    'X-Tenant-ID': TENANT_ID
});

const TENANT_BRE_POST_HEADER = addAuthGetter({
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Tenant-ID': TENANT_ID
});

const GET_HEADER = createDualHeader({});

const GET_HEADER_EXCEL = createDualHeader({
     'Content-Type': 'application/vnd.ms-excel',
});

const GET_HEADER_CUSTOM_KEYS = createDualHeader({
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': PARTICULAR_KEY
});

const TENANT_HEADER = {
    headers: addAuthGetter({
        'X-Tenant-ID': TENANT_ID,
    })
};

// for bre enable token from here 
const buildTenantHeader = (tenantId) => {
    const h = { 'X-Tenant-ID': tenantId ?? TENANT_ID };
    const auth = getAuthHeaderValue();
    // if (auth) {
    //     h['Token'] = auth;
    // }
    return { headers: h };
};

const buildTenantPostHeader = (tenantId) => {
    const h = {
        'X-Tenant-ID': tenantId ?? TENANT_ID,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    };
    const auth = getAuthHeaderValue();
    // if (auth) {
    //     h['Token'] = auth;
    // }
    return { headers: h };
};

export {
    TENANT_POST_HEADER,
    POST_HEADER,
    GET_HEADER,
    TENANT_HEADER,
    TENANT_BRE_POST_HEADER,
    MULTIPART_TENANT_POST_HEADER,
    MULTIPART_POST_HEADER,
    buildTenantHeader,
    buildTenantPostHeader,
    GET_HEADER_CUSTOM_KEYS,
    POST_HEADER_NO_TOKEN,
    GET_HEADER_EXCEL,
    DELETE_HEADERS,
    PUT_HEADERS,
}